<template>
  <h1>Error</h1>
</template>

<script>
export default {

}
</script>

<style>

</style>